import { Layer, Source } from "react-map-gl/mapbox"

interface PollutionLayerProps {
  opacity?: number
}

export const PollutionLayer = ({ opacity = 0.7 }: PollutionLayerProps) => {
  return (
    <>
      <Source
        id="raster-pollution1"
        type="raster"
        tiles={[
          "https://mapsref.brgm.fr/wxs/georisques/risques?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&LAYERS=SSP_INSTRUCTION&STYLES=&CRS=EPSG%3A3857&TILED=true&WIDTH=256&HEIGHT=256&BBOX={bbox-epsg-3857}",
        ]}
        tileSize={256}
        maxzoom={15}
      >
        <Layer id="raster-pollution1" type="raster" source="raster-pollution1" paint={{ "raster-opacity": opacity }} />
      </Source>
      <Source
        id="raster-pollution2"
        type="raster"
        tiles={[
          "https://mapsref.brgm.fr/wxs/georisques/risques?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&LAYERS=SSP_CLASSIFICATION_SUP&STYLES=&CRS=EPSG%3A3857&TILED=true&WIDTH=256&HEIGHT=256&BBOX={bbox-epsg-3857}",
        ]}
        tileSize={256}
        maxzoom={15}
      >
        <Layer id="raster-pollution2" type="raster" source="raster-pollution2" paint={{ "raster-opacity": opacity }} />
      </Source>
      <Source
        id="raster-pollution3"
        type="raster"
        tiles={[
          "https://mapsref.brgm.fr/wxs/georisques/risques?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&LAYERS=SSP_CLASSIF_SUP_GE&STYLES=&CRS=EPSG%3A3857&TILED=true&WIDTH=256&HEIGHT=256&BBOX={bbox-epsg-3857}",
        ]}
        tileSize={256}
        maxzoom={15}
      >
        <Layer id="raster-pollution3" type="raster" source="raster-pollution3" paint={{ "raster-opacity": opacity }} />
      </Source>
    </>
  )
}
